<template>
  <div class="dashboard-container">
    <!-- 科技背景效果 - 已简化以提升性能 -->
    <div class="tech-bg">
      <!-- 移除了粒子、全息线、网格和扫描线动画以提升性能 -->
    </div>
    
    <el-container>
      <el-header class="dashboard-header">
        <div class="header-border"></div>
        <h2>
          <span class="header-title">IP归属地查询管理系统</span>
          <span class="header-glow"></span>
        </h2>
        <div class="user-info">
          <span class="user-name">{{ username }}</span>
          <el-button type="text" @click="showChangePasswordDialog" class="header-btn">修改密码</el-button>
          <el-button type="text" @click="handleLogout" class="header-btn">退出</el-button>
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px" class="dashboard-aside">
          <div class="aside-border"></div>
          <el-menu
            :default-active="activeMenu"
            @select="handleMenuSelect"
            background-color="transparent"
            text-color="#606266"
            active-text-color="#409EFF"
          >
            <el-menu-item index="stats">
              <i class="el-icon-data-line"></i>
              <span>查询统计</span>
            </el-menu-item>
            <el-menu-item index="systemLog">
              <i class="el-icon-document-copy"></i>
              <span>系统日志</span>
            </el-menu-item>
            <el-menu-item index="ipData">
              <i class="el-icon-document"></i>
              <span>IP数据管理</span>
            </el-menu-item>
            <el-menu-item index="apiKey">
              <i class="el-icon-key"></i>
              <span>API Key管理</span>
            </el-menu-item>
            <el-menu-item index="verify">
              <i class="el-icon-search"></i>
              <span>IP验证</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main class="dashboard-main">
          <!-- IP数据管理 -->
          <div v-show="activeMenu === 'ipData'" class="content-section">
            <el-row :gutter="20">
              <el-col :span="10">
                <el-card>
              <div slot="header">
                <span>IP数据管理</span>
              </div>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-card class="stat-card">
                    <div class="stat-content">
                      <i class="el-icon-tickets stat-icon"></i>
                      <div>
                        <div class="stat-value">{{ ipDataCount }}</div>
                        <div class="stat-label">IP数据总数</div>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
              <el-divider></el-divider>
             <el-upload
                class="upload-demo"
                action=""
                :http-request="handleUpload"
                :before-upload="beforeUpload"
                :show-file-list="false"
                accept=".csv,.txt"
              >
                <el-button type="primary" icon="el-icon-upload">上传IP数据文件</el-button>
                <div slot="tip" class="el-upload__tip">
                  支持CSV格式（逗号分隔）和ip2region格式（竖线分隔）。导入前会自动备份现有数据。
                </div>
              </el-upload>
              
              <el-divider></el-divider>
              
              <el-button type="success" icon="el-icon-download" @click="handleOnlineUpdate" :loading="onlineUpdating">
                在线更新（从 Gitee 下载最新数据）
              </el-button>
              <div style="margin-top: 10px; color: #999; font-size: 13px;">
                <i class="el-icon-info"></i> 在线更新将自动从 Gitee 下载 ip2region 最新数据并导入，备份策略与上传文件相同
              </div>
              
              <!-- 导入进度显示 -->
              <el-card v-if="importProgress.importing" style="margin-top: 20px;" shadow="hover">
                <div slot="header">
                  <i class="el-icon-loading"></i> 导入进度
                </div>
                <div>
                  <div style="margin-bottom: 15px;">
                    <el-progress :percentage="importProgress.percentage" :status="importProgress.percentage === 100 ? 'success' : ''"></el-progress>
                  </div>
                  <div style="margin-bottom: 10px;">
                    <el-tag type="info" size="small">当前状态</el-tag>
                    <span style="margin-left: 10px; color: #409EFF;">{{ importProgress.message }}</span>
                  </div>
                  <div>
                    <el-tag type="success" size="small">处理进度</el-tag>
                    <span style="margin-left: 10px;">
                      {{ importProgress.processedLines.toLocaleString() }} / {{ importProgress.totalLines.toLocaleString() }} 行
                    </span>
                  </div>
                </div>
              </el-card>
            </el-card>
            
            <!-- 自动更新设置 -->
            <el-card style="margin-top: 20px;">
              <div slot="header" class="auto-update-header">
                <span>自动更新设置</span>
                <span style="margin-left: 10px;">
                  <el-tag size="small" :type="autoUpdate && autoUpdate.lastUpdateStatus === 'success' ? 'success' : (autoUpdate && autoUpdate.lastUpdateStatus === 'failed' ? 'danger' : 'info')">
                    {{ (autoUpdate && autoUpdate.lastUpdateStatus) || '未执行' }}
                  </el-tag>
                </span>
                <div style="float: right;">
                  <el-button-group>
                    <el-button size="mini" type="primary" @click="saveAutoUpdateConfig" :loading="autoUpdateSaving">保存设置</el-button>
                    <el-button size="mini" type="success" @click="triggerAutoUpdate" :loading="autoUpdateTriggering" style="margin-left: 1em;">立即更新</el-button>
                  </el-button-group>
                </div>
              </div>
              <el-form :model="autoUpdate" inline label-width="90px" size="small">
                <el-form-item label="开启">
                  <el-switch v-model="autoUpdate.enabled" @change="saveAutoUpdateConfig"></el-switch>
                </el-form-item>
                <el-form-item label="频率">
                  <el-select v-model="autoUpdate.frequency" style="width: 120px;" @change="saveAutoUpdateConfig">
                    <el-option label="每天" value="daily"></el-option>
                    <el-option label="每周" value="weekly"></el-option>
                    <el-option label="每月" value="monthly"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="时间">
                  <el-time-picker v-model="autoUpdateTime" placeholder="选择时间" value-format="HH:mm" format="HH:mm" @change="onTimeChange" style="width: 120px;"></el-time-picker>
                </el-form-item>
                <el-form-item v-if="autoUpdate.frequency === 'weekly'" label="星期">
                  <el-select v-model="autoUpdate.weekDay" style="width: 120px;" @change="saveAutoUpdateConfig">
                    <el-option v-for="d in 7" :key="d" :label="'周' + '一二三四五六日'[d-1]" :value="d"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="autoUpdate.frequency === 'monthly'" label="日期">
                  <el-input-number v-model="autoUpdate.monthDay" :min="1" :max="28" @change="saveAutoUpdateConfig"></el-input-number>
                </el-form-item>

              </el-form>
              <el-divider></el-divider>
              <div style="font-size: 13px; color: #666;">
                <div>上次更新时间：{{ formatDateTime(autoUpdate && autoUpdate.lastUpdateTime) || '-' }}</div>
                <div>下次更新时间：{{ formatDateTime(autoUpdate && autoUpdate.nextUpdateTime) || '-' }}</div>
                <div v-if="autoUpdate && autoUpdate.lastUpdateMessage">上次更新消息：{{ autoUpdate.lastUpdateMessage }}</div>
              </div>
            </el-card>
              </el-col>
              
              <el-col :span="14">
                
                <!-- 备份管理 -->
                <el-card>
              <div slot="header">
                <span>数据备份管理</span>
                <span style="float: right; color: #999; font-size: 12px;">最多保留10条备份</span>
              </div>
              <el-table :data="backups" border style="width: 100%" v-if="backups.length > 0" fit>
                <el-table-column prop="backupName" label="备份名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="recordCount" label="数据条数" align="center">
                  <template slot-scope="scope">
                    <el-tag type="info">{{ scope.row.recordCount }} 条</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="createdAt" label="备份时间" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" type="success" @click="restoreBackup(scope.row.id)">恢复</el-button>
                    <span style="display: inline-block; width: 1em;"></span>
                    <el-button size="mini" type="danger" @click="deleteBackup(scope.row.id)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-empty v-else description="暂无备份记录" :image-size="80"></el-empty>
            </el-card>
              </el-col>
            </el-row>
          </div>

          <!-- API Key管理 -->
          <div v-show="activeMenu === 'apiKey'" class="content-section">
            <el-card>
              <div slot="header">
                <span>API Key管理</span>
                <el-button type="primary" size="small" @click="showGenerateDialog" style="float: right;">
                  生成新Key
                </el-button>
              </div>
              <el-table :data="apiKeys" border style="width: 100%" fit>
                <el-table-column prop="apiName" label="API名称" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="apiKey" label="API Key" min-width="250" show-overflow-tooltip></el-table-column>
                <el-table-column prop="secretKey" label="Secret Key" min-width="250" show-overflow-tooltip></el-table-column>
                <el-table-column prop="queryCount" label="查询次数" min-width="100" align="center"></el-table-column>
                <el-table-column prop="dailyLimit" label="每日限额" min-width="100" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.dailyLimit === -1 ? '无限制' : scope.row.dailyLimit }}
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" min-width="80" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
                      {{ scope.row.status === 1 ? '启用' : '禁用' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="280" align="center" fixed="right">
                  <template slot-scope="scope">
                    <el-button size="mini" class="api-interface-btn" @click="copyApiInfo(scope.row)">接口</el-button>
                    <el-button size="mini" type="primary" @click="showEditDialog(scope.row)" style="margin-left: 1em;">编辑</el-button>
                    <el-button
                      size="mini"
                      :type="scope.row.status === 1 ? 'warning' : 'success'"
                      @click="toggleStatus(scope.row)"
                      style="margin-left: 1em;"
                    >{{ scope.row.status === 1 ? '禁用' : '启用' }}</el-button>
                    <el-button size="mini" type="danger" @click="deleteKey(scope.row.id)" style="margin-left: 1em;">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </div>

          <!-- IP验证 -->
          <div v-show="activeMenu === 'verify'" class="content-section">
            <el-card>
              <div slot="header">
                <span>IP验证工具</span>
              </div>
              <el-form :model="verifyForm" inline>
                <el-form-item label="IP地址">
                  <el-input v-model="verifyForm.ip" placeholder="请输入IP地址"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="handleVerify">查询</el-button>
                </el-form-item>
              </el-form>
              <el-divider></el-divider>
              <div v-if="verifyResult" class="verify-result">
                <h3>查询结果</h3>
                <el-descriptions :column="2" border>
                  <el-descriptions-item label="IP地址">{{ verifyResult.ip }}</el-descriptions-item>
                  <el-descriptions-item label="查询状态">
                    <el-tag :type="verifyResult.found ? 'success' : 'danger'">
                      {{ verifyResult.found ? '找到' : '未找到' }}
                    </el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item label="国家">{{ verifyResult.country || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="省份">{{ verifyResult.province || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="城市">{{ verifyResult.city || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="运营商">{{ verifyResult.isp || '-' }}</el-descriptions-item>
                </el-descriptions>
              </div>
            </el-card>
          </div>

          <!-- 系统日志 -->
          <div v-show="activeMenu === 'systemLog'" class="content-section">
            <el-card>
              <div slot="header">
                <span>系统日志</span>
              </div>
              
              <!-- 筛选条件 -->
              <el-form :inline="true" size="small" style="margin-bottom: 15px;">
                <el-form-item label="用户名">
                  <el-input v-model="systemLogFilter.username" placeholder="请输入用户名" clearable style="width: 150px;" @change="applySystemLogFilter"></el-input>
                </el-form-item>
                
                <el-form-item label="操作时间">
                  <el-date-picker
                    v-model="systemLogFilter.dateRange"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    style="width: 380px;"
                    @change="applySystemLogFilter">
                  </el-date-picker>
                </el-form-item>
                
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="applySystemLogFilter">查询</el-button>
                  <el-button
                    icon="el-icon-refresh"
                    class="stats-reset-btn"
                    @click="resetSystemLogFilter"
                  >重置</el-button>
                </el-form-item>
              </el-form>
              
              <!-- 数据表格 -->
              <el-table :data="systemLogs" border style="width: 100%" fit v-loading="systemLogLoading">
                <el-table-column prop="username" label="用户名" width="120" align="center"></el-table-column>
                <el-table-column prop="operationTime" label="操作时间" width="180" align="center"></el-table-column>
                <el-table-column prop="loginIp" label="登录IP" width="150" align="center"></el-table-column>
                <el-table-column prop="location" label="归属地" width="250" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.location || '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="operationContent" label="操作内容" min-width="200" show-overflow-tooltip></el-table-column>
              </el-table>
              
              <!-- 分页 -->
              <div style="margin-top: 15px; text-align: right;">
                <el-pagination
                  @size-change="handleSystemLogSizeChange"
                  @current-change="handleSystemLogPageChange"
                  :current-page="systemLogPage + 1"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="systemLogPageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="systemLogTotal">
                </el-pagination>
              </div>
            </el-card>
          </div>

          <!-- 查询统计 -->
          <div v-show="activeMenu === 'stats'" class="content-section">
            <el-card>
              <div slot="header">
                <span>查询统计</span>
              </div>
              
              <!-- 筛选条件 -->
              <el-form :inline="true" size="small" style="margin-bottom: 15px;">
                <el-form-item label="API名称">
                  <el-select v-model="statsFilter.apiName" placeholder="全部" clearable style="width: 150px;" @change="applyFilter">
                    <el-option label="全部" value=""></el-option>
                    <el-option 
                      v-for="api in apiKeys" 
                      :key="api.id" 
                      :label="api.apiName" 
                      :value="api.apiName">
                    </el-option>
                  </el-select>
                </el-form-item>
                
                <el-form-item label="客户端IP">
                  <el-input v-model="statsFilter.clientIp" placeholder="请输入IP" clearable style="width: 150px;" @change="applyFilter"></el-input>
                </el-form-item>
                
                <el-form-item label="查询日期">
                  <el-date-picker
                    v-model="statsFilter.dateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 240px;"
                    @change="applyFilter">
                  </el-date-picker>
                </el-form-item>
                
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="applyFilter">查询</el-button>
                  <el-button
                    icon="el-icon-refresh"
                    class="stats-reset-btn"
                    @click="resetFilter"
                  >重置</el-button>
                  <el-button type="success" icon="el-icon-data-analysis" @click="showStatsAnalysis">数据分析</el-button>
                </el-form-item>
              </el-form>
              
              <!-- 数据表格 -->
              <el-table :data="displayedQueryLogs" border style="width: 100%" fit>
                <el-table-column prop="apiName" label="API名称" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ipAddress" label="查询IP" width="150"></el-table-column>
                <el-table-column prop="queryResult" label="查询结果" min-width="250" show-overflow-tooltip></el-table-column>
                <el-table-column label="客户端IP" width="280">
                  <template slot-scope="scope">
                    <span v-if="scope.row.clientLocation">
                      {{ scope.row.clientIp }}（{{ scope.row.clientLocation }}）
                    </span>
                    <span v-else>{{ scope.row.clientIp || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="queryTime" label="查询时间" width="180"></el-table-column>
              </el-table>
              
              <!-- 统计信息 -->
              <div style="margin-top: 15px; color: #909399; font-size: 13px;">
                显示 {{ displayedQueryLogs.length }} / {{ filteredQueryLogs.length }} 条记录（默认展示最近 {{ statsDisplayLimit }} 条）
              </div>
            </el-card>
          </div>
        </el-main>
      </el-container>
    </el-container>

    <!-- 生成API Key对话框 -->
    <el-dialog title="生成新的API Key" :visible.sync="generateDialogVisible" width="500px">
      <el-form :model="generateForm" :rules="generateRules" ref="generateForm">
        <el-form-item label="API名称" prop="apiName" label-width="100px">
          <el-input v-model="generateForm.apiName" placeholder="请输入API名称"></el-input>
        </el-form-item>
        <el-form-item label="每日限额" label-width="100px">
          <el-input-number v-model="generateForm.dailyLimit" :min="-1" placeholder="-1表示无限制"></el-input-number>
          <span style="margin-left: 10px; color: #999;">-1表示无限制</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="generateDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleGenerate">生成</el-button>
      </div>
    </el-dialog>

    <!-- 编辑API Key对话框 -->
    <el-dialog title="编辑API Key" :visible.sync="editDialogVisible" width="500px">
      <el-form :model="editForm" :rules="generateRules" ref="editForm">
        <el-form-item label="API名称" prop="apiName" label-width="100px">
          <el-input v-model="editForm.apiName" placeholder="请输入API名称"></el-input>
        </el-form-item>
        <el-form-item label="每日限额" label-width="100px">
          <el-input-number v-model="editForm.dailyLimit" :min="-1" placeholder="-1表示无限制"></el-input-number>
          <span style="margin-left: 10px; color: #999;">-1表示无限制</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleEdit">保存</el-button>
      </div>
    </el-dialog>

    <!-- API调用示例预览对话框 -->
    <el-dialog title="API 调用示例" :visible.sync="apiPreviewDialogVisible" width="800px" top="5vh">
      <div class="api-preview-content" v-html="apiPreviewContent"></div>
      <div slot="footer">
        <el-button type="primary" @click="apiPreviewDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 数据分析对话框 -->
    <el-dialog title="数据分析" :visible.sync="analysisDialogVisible" width="900px" top="5vh">
      <el-tabs v-model="activeAnalysisTab">
        <!-- API统计 -->
        <el-tab-pane label="API统计" name="api">
          <el-table :data="apiStats" border style="width: 100%;" max-height="400" fit>
            <el-table-column prop="apiName" label="API名称" width="400" show-overflow-tooltip></el-table-column>
            <el-table-column prop="count" label="调用次数" width="150" align="center" sortable></el-table-column>
            <el-table-column label="占比" width="150" align="center">
              <template slot-scope="scope">
                {{ ((scope.row.count / filteredQueryLogs.length) * 100).toFixed(2) }}%
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        
        <!-- 地区统计 -->
        <el-tab-pane label="地区统计" name="location">
          <!-- 地区筛选条件 -->
          <el-form :inline="true" size="small" style="margin-bottom: 15px;">
            <el-form-item label="国家">
              <el-select v-model="locationFilter.country" placeholder="全部" clearable style="width: 150px;" @change="filterLocationStats">
                <el-option label="全部" value=""></el-option>
                <el-option 
                  v-for="country in uniqueCountries" 
                  :key="country" 
                  :label="country" 
                  :value="country">
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="省份">
              <el-select v-model="locationFilter.province" placeholder="全部" clearable style="width: 150px;" @change="filterLocationStats">
                <el-option label="全部" value=""></el-option>
                <el-option 
                  v-for="province in uniqueProvinces" 
                  :key="province" 
                  :label="province" 
                  :value="province">
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="城市">
              <el-select v-model="locationFilter.city" placeholder="全部" clearable style="width: 150px;" @change="filterLocationStats">
                <el-option label="全部" value=""></el-option>
                <el-option 
                  v-for="city in uniqueCities" 
                  :key="city" 
                  :label="city" 
                  :value="city">
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item>
              <el-button icon="el-icon-refresh" @click="resetLocationFilter">重置</el-button>
            </el-form-item>
          </el-form>
          
          <el-table :data="filteredLocationStats" border style="width: 100%;" max-height="400" fit>
            <el-table-column prop="location" label="地区" width="450" show-overflow-tooltip></el-table-column>
            <el-table-column prop="count" label="查询次数" width="150" align="center" sortable></el-table-column>
            <el-table-column label="占比" width="150" align="center">
              <template slot-scope="scope">
                {{ ((scope.row.count / filteredQueryLogs.length) * 100).toFixed(2) }}%
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        
        <!-- 客户端IP统计 -->
        <el-tab-pane label="客户端IP统计" name="clientIp">
          <el-table :data="clientIpStats" border style="width: 100%;" max-height="400" fit>
            <el-table-column prop="clientIp" label="客户端IP" width="200"></el-table-column>
            <el-table-column prop="location" label="归属地" width="350" show-overflow-tooltip></el-table-column>
            <el-table-column prop="count" label="查询次数" width="150" align="center" sortable></el-table-column>
          </el-table>
        </el-tab-pane>
        
        <!-- 日期统计 -->
        <el-tab-pane label="日期统计" name="time">
          <el-table :data="timeStats" border style="width: 100%;" max-height="400" fit>
            <el-table-column prop="date" label="日期" width="400"></el-table-column>
            <el-table-column prop="count" label="查询次数" width="150" align="center" sortable></el-table-column>
            <el-table-column label="占比" width="150" align="center">
              <template slot-scope="scope">
                {{ ((scope.row.count / filteredQueryLogs.length) * 100).toFixed(2) }}%
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      
      <div slot="footer">
        <el-button type="primary" @click="analysisDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    
    <!-- 修改密码对话框 -->
    <el-dialog title="修改密码" :visible.sync="changePasswordDialogVisible" width="450px">
      <el-form :model="changePasswordForm" :rules="changePasswordRules" ref="changePasswordForm" label-width="100px">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="changePasswordForm.oldPassword" type="password" placeholder="请输入旧密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="changePasswordForm.newPassword" type="password" placeholder="请输入新密码（6位以上）" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="changePasswordForm.confirmPassword" type="password" placeholder="再次输入新密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="changePasswordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleChangePassword" :loading="changePasswordLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      activeMenu: 'stats',
      username: '',
      ipDataCount: 0,
      onlineUpdating: false,  // 在线更新状态
      importProgress: {  // 导入进度
        importing: false,
        totalLines: 0,
        processedLines: 0,
        message: '就绪',
        percentage: 0
      },
      backups: [],  // 备份列表
      apiKeys: [],
      queryLogs: [],
      filteredQueryLogs: [],  // 筛选后的查询日志
      verifyForm: {
        ip: ''
      },
      verifyResult: null,
      generateDialogVisible: false,
      editDialogVisible: false,  // 编辑对话框
      apiPreviewDialogVisible: false,  // API示例预览对话框
      apiPreviewContent: '',  // API示例内容
      analysisDialogVisible: false,  // 数据分析对话框
      activeAnalysisTab: 'api',  // 当前分析标签页
      apiStats: [],  // API统计数据
      locationStats: [],  // 地区统计数据
      filteredLocationStats: [],  // 筛选后的地区统计
      locationDetails: [],  // 地区详细信息（包含国家、省、市）
      locationFilter: {  // 地区筛选条件
        country: '',
        province: '',
        city: ''
      },
      clientIpStats: [],  // 客户端IP统计数据
      timeStats: [],  // 时间统计数据
      generateForm: {
        apiName: '',
        dailyLimit: -1
      },
      editForm: {
        id: null,
        apiName: '',
        dailyLimit: -1
      },
      generateRules: {
        apiName: [
          { required: true, message: '请输入API名称', trigger: 'blur' }
        ]
      },
      statsFilter: {
        apiName: '',
        clientIp: '',
        dateRange: ''
      },
      statsDisplayLimit: 100,  // 优化：增加到100条提升用户体验
      // 系统日志相关
      systemLogs: [],
      systemLogLoading: false,
      systemLogPage: 0,
      systemLogPageSize: 20,
      systemLogTotal: 0,
      systemLogFilter: {
        username: '',
        dateRange: ''
      },
      autoUpdate: {
        enabled: false,
        frequency: 'daily',
        updateHour: 3,
        updateMinute: 0,
        weekDay: 1,
        monthDay: 1,
        lastUpdateTime: null,
        lastUpdateStatus: null,
        lastUpdateMessage: null,
        nextUpdateTime: null
      },
      autoUpdateSaving: false,
      autoUpdateTriggering: false,
      autoUpdateTime: '03:00',
      changePasswordDialogVisible: false,
      changePasswordLoading: false,
      changePasswordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      changePasswordRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: (rule, value, callback) => {
              if (value !== this.changePasswordForm.newPassword) {
                callback(new Error('两次输入的密码不一致'))
              } else {
                callback()
              }
            }, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    displayedQueryLogs() {
      return this.filteredQueryLogs.slice(0, this.statsDisplayLimit)
    },
    // 获取所有唯一国家
    uniqueCountries() {
      const countries = new Set()
      this.locationDetails.forEach(item => {
        if (item.country) countries.add(item.country)
      })
      return Array.from(countries).sort()
    },
    // 获取筛选后的省份（基于选中的国家）
    uniqueProvinces() {
      const provinces = new Set()
      this.locationDetails.forEach(item => {
        if (this.locationFilter.country) {
          if (item.country === this.locationFilter.country && item.province) {
            provinces.add(item.province)
          }
        } else {
          if (item.province) provinces.add(item.province)
        }
      })
      return Array.from(provinces).sort()
    },
    // 获取筛选后的城市（基于选中的省份）
    uniqueCities() {
      const cities = new Set()
      this.locationDetails.forEach(item => {
        if (this.locationFilter.province) {
          if (item.province === this.locationFilter.province && item.city) {
            cities.add(item.city)
          }
        } else if (this.locationFilter.country) {
          if (item.country === this.locationFilter.country && item.city) {
            cities.add(item.city)
          }
        } else {
          if (item.city) cities.add(item.city)
        }
      })
      return Array.from(cities).sort()
    }
  },
  created() {
    this.loadAutoUpdateConfig()
  },
  mounted() {
    const user = this.$store.state.user
    this.username = user ? user.nickname || user.username : '管理员'
    this.loadIpDataStats()
    this.loadBackups()  // 加载备份列表
    this.loadApiKeys()
    this.loadQueryLogs()
  },
  methods: {
    // 已移除getParticleStyle方法以提升性能
    handleMenuSelect(index) {
      this.activeMenu = index
      if (index === 'stats') {
        this.loadQueryLogs()
      } else if (index === 'systemLog') {
        this.loadSystemLogs()
      }
    },
    async loadIpDataStats() {
      try {
        const { data } = await this.$axios.get('/admin/ip/stats')
        if (data.code === 200) {
          this.ipDataCount = data.data.totalCount
        }
      } catch (error) {
        console.error('加载统计失败', error)
      }
    },
    async loadBackups() {
      try {
        const { data } = await this.$axios.get('/admin/ip/backups')
        if (data.code === 200) {
          this.backups = data.data
        }
      } catch (error) {
        console.error('加载备份列表失败', error)
      }
    },
    async loadApiKeys() {
      try {
        const { data } = await this.$axios.get('/admin/apikey/list')
        if (data.code === 200) {
          this.apiKeys = data.data
        }
      } catch (error) {
        console.error('加载API Key失败', error)
      }
    },
    async loadQueryLogs() {
      try {
        const { data } = await this.$axios.get('/admin/ip/logs')
        if (data.code === 200) {
          const sortedLogs = this.sortQueryLogs(data.data)
          this.queryLogs = sortedLogs
          this.filteredQueryLogs = sortedLogs  // 初始化筛选后的数据
        }
      } catch (error) {
        console.error('加载查询日志失败', error)
      }
    },
    beforeUpload(file) {
      console.log('准备上传文件:', file.name, '类型:', file.type)
      const isValidFile = file.type === 'text/csv' || 
                         file.type === 'text/plain' || 
                         file.name.endsWith('.csv') || 
                         file.name.endsWith('.txt')
      if (!isValidFile) {
        this.$message.error('只支持CSV或TXT格式文件')
        return false
      }
      console.log('文件格式检查通过')
      return true
    },
    async handleUpload({ file }) {
      console.log('开始上传文件:', file.name)
      
      // 第一步：预览文件
      const formData = new FormData()
      formData.append('file', file)
      
      try {
        const loading = this.$loading({
          lock: true,
          text: '正在分析文件...',
          spinner: 'el-icon-loading'
        })
        
        const { data } = await this.$axios.post('/admin/ip/preview', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        
        loading.close()
        
        if (data.code !== 200) {
          this.$message.error(data.message)
          return
        }
        
        // 第二步：显示预览信息并让用户确认
        const preview = data.data
        const fileSize = (preview.fileSize / 1024 / 1024).toFixed(2)
        
        let message = `<div style="text-align: left;">
          <p><strong>文件名：</strong>${preview.fileName}</p>
          <p><strong>文件大小：</strong>${fileSize} MB</p>
          <p><strong>文件格式：</strong>${preview.fileFormat}</p>
          <p><strong>文件数据条数：</strong><span style="color: #67C23A; font-weight: bold;">${preview.fileLineCount} 条</span></p>
          <p><strong>当前数据库记录：</strong><span style="color: #409EFF; font-weight: bold;">${preview.currentDbCount} 条</span></p>
          <hr style="margin: 10px 0;"/>
          <p style="color: #E6A23C;"><i class="el-icon-warning"></i> 操作说明：</p>
          <ul style="margin: 5px 0; padding-left: 20px; color: #606266;">`
        
        if (preview.willBackup) {
          message += `<li>将会自动备份当前 ${preview.currentDbCount} 条数据</li>`
        }
        
        message += `<li>清空数据库现有数据</li>
            <li>导入 ${preview.fileLineCount} 条新数据</li>
          </ul>
          <p style="color: #909399; font-size: 12px; margin-top: 10px;">
            <i class="el-icon-info"></i> 当前已有 <strong>${preview.backupCount}</strong> 条备份记录，最多保留10条
          </p>
        </div>`
        
        this.$confirm(message, '确认导入数据', {
          confirmButtonText: '确定导入',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          customClass: 'import-confirm-dialog'
        }).then(async () => {
          // 第三步：用户确认后，开始实际导入
          await this.doImport(file)
        }).catch(() => {
          this.$message.info('已取消导入')
        })
        
      } catch (error) {
        console.error('预览失败:', error)
        this.$message.error('文件预览失败: ' + (error.response?.data?.message || error.message))
      }
    },
    async doImport(file) {
      const formData = new FormData()
      formData.append('file', file)
      
      const loading = this.$loading({
        lock: true,
        text: '正在上传并导入数据，请稍候...',
        spinner: 'el-icon-loading',
        customClass: 'upload-loading'
      })
      
      // 启动进度轮询（优化：降低轮询频率）
      const progressTimer = setInterval(async () => {
        try {
          const { data } = await this.$axios.get('/admin/ip/import-progress')
          if (data.code === 200 && data.data.importing) {
            const progress = data.data
            loading.text = `${progress.message} (${progress.percentage}%)`
          }
        } catch (error) {
          console.error('获取进度失败:', error)
        }
      }, 2000)  // 优化：改为每2秒更新1次
      
      try {
        const { data } = await this.$axios.post('/admin/ip/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 600000 // 10分钟超时
        })
        
        clearInterval(progressTimer)
        loading.close()
        
        if (data.code === 200) {
          this.$message.success(`导入成功！共导入 ${data.data.totalCount} 条数据`)
          this.loadIpDataStats()
          this.loadBackups()  // 刷新备份列表
        } else {
          this.$message.error(data.message)
        }
      } catch (error) {
        console.error('上传失败:', error)
        clearInterval(progressTimer)
        loading.close()
        this.$message.error('上传失败: ' + (error.response?.data?.message || error.message))
      }
    },
    handleClearData() {
      this.$confirm('确定要清空所有IP数据吗？此操作不可恢复！', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await this.$axios.delete('/admin/ip/clear')
          if (data.code === 200) {
            this.$message.success('数据已清空')
            this.loadIpDataStats()
          }
        } catch (error) {
          this.$message.error('清空失败')
        }
      })
    },
    async handleImportIp2Region() {
      this.$confirm('确定要导入ip2region数据吗？导入过程需要 2-5 分钟，将导入约70万条IP数据。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: '正在导入IP数据，请耐心等候（预计 2-5 分钟）...',
          spinner: 'el-icon-loading'
        })
        
        // 启动进度轮询（优化：降低轮询频率）
        const progressTimer = setInterval(async () => {
          try {
            const { data } = await this.$axios.get('/admin/ip/import-progress')
            if (data.code === 200 && data.data.importing) {
              const progress = data.data
              loading.text = `${progress.message} (${progress.percentage}%)`
            }
          } catch (error) {
            console.error('获取进度失败:', error)
          }
        }, 2000)  // 优化：改为每2秒更新1次
        
        try {
          const { data } = await this.$axios.post('/admin/ip/import-ip2region', null, {
            timeout: 600000 // 10分钟超时
          })
          
          clearInterval(progressTimer)
          loading.close()
          
          if (data.code === 200) {
            this.$message.success(`IP数据导入成功！共导入 ${data.data.totalCount} 条数据`)
            this.loadIpDataStats()
            this.loadBackups()  // 刷新备份列表
          } else {
            this.$message.error(data.message)
          }
        } catch (error) {
          clearInterval(progressTimer)
          loading.close()
          this.$message.error('导入失败: ' + (error.response?.data?.message || error.message))
        }
      })
    },
    showGenerateDialog() {
      this.generateDialogVisible = true
      this.generateForm = {
        apiName: '',
        dailyLimit: -1
      }
    },
    handleGenerate() {
      this.$refs.generateForm.validate(async (valid) => {
        if (valid) {
          try {
            const { data } = await this.$axios.post('/admin/apikey/generate', this.generateForm)
            if (data.code === 200) {
              this.$message.success('API Key生成成功')
              this.generateDialogVisible = false
              this.loadApiKeys()
              this.showApiKeyInfo(data.data)
            }
          } catch (error) {
            this.$message.error('生成失败')
          }
        }
      })
    },
    showApiKeyInfo(apiKey) {
      const info = `API Key: ${apiKey.apiKey}
Secret Key: ${apiKey.secretKey}

调用示例:
GET /api/query/ip?ip=8.8.8.8&apiKey=${apiKey.apiKey}`
      this.$alert(info, '生成成功', {
        confirmButtonText: '复制',
        callback: () => {
          this.copyToClipboard(info)
        }
      })
    },
    copyApiInfo(row) {
      const baseUrl = window.location.origin + '/api'
      const info = `=================================
API 调用示例
=================================

API 名称: ${row.apiName}
API Key: ${row.apiKey}
Secret Key: ${row.secretKey}

---------------------------------
调用方式 1: GET 请求
---------------------------------
请求地址:
${baseUrl}/query/ip?ip=8.8.8.8&apiKey=${row.apiKey}

cURL 示例:
curl "${baseUrl}/query/ip?ip=8.8.8.8&apiKey=${row.apiKey}"

---------------------------------
调用方式 2: POST 请求
---------------------------------
请求地址:
${baseUrl}/query/ip

请求头:
Content-Type: application/json

请求体:
{
  "ip": "8.8.8.8",
  "apiKey": "${row.apiKey}"
}

cURL 示例:
curl -X POST "${baseUrl}/query/ip" \\
  -H "Content-Type: application/json" \\
  -d '{
    "ip": "8.8.8.8",
    "apiKey": "${row.apiKey}"
  }'

---------------------------------
返回数据格式
---------------------------------
成功示例:
{
  "code": 200,
  "message": "success",
  "data": {
    "ip": "8.8.8.8",
    "country": "美国",
    "province": "",
    "city": "",
    "isp": "Google",
    "found": true
  }
}

未找到示例:
{
  "code": 200,
  "message": "success",
  "data": {
    "ip": "1.2.3.4",
    "country": null,
    "province": null,
    "city": null,
    "isp": null,
    "found": false
  }
}

错误示例:
{
  "code": 400,
  "message": "IP地址格式不正确",
  "data": null
}

=================================`
      
      // 复制到剪贴板
      this.copyToClipboard(info)
      this.$message.success('已复制到剪贴板')
      
      // 显示预览窗口（使用 Markdown 样式）
      this.apiPreviewContent = this.convertToHtml(row, baseUrl)
      this.apiPreviewDialogVisible = true
    },
    convertToHtml(row, baseUrl) {
      return `
        <div style="line-height: 1.8; font-family: 'Monaco', 'Courier New', monospace;">
          <h2 style="color: #409EFF; border-bottom: 2px solid #409EFF; padding-bottom: 10px;">🔑 API 调用示例</h2>
          
          <h3 style="color: #67C23A; margin-top: 20px;">⚙️ 基本信息</h3>
          <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
            <tr style="background: #f5f7fa;">
              <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold; width: 150px;">API 名称</td>
              <td style="padding: 8px; border: 1px solid #ddd;">${row.apiName}</td>
            </tr>
            <tr>
              <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold;">API Key</td>
              <td style="padding: 8px; border: 1px solid #ddd;"><code style="background: #f0f0f0; padding: 2px 6px; border-radius: 3px;">${row.apiKey}</code></td>
            </tr>
            <tr style="background: #f5f7fa;">
              <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold;">Secret Key</td>
              <td style="padding: 8px; border: 1px solid #ddd;"><code style="background: #f0f0f0; padding: 2px 6px; border-radius: 3px;">${row.secretKey}</code></td>
            </tr>
          </table>

          <h3 style="color: #67C23A; margin-top: 25px;">🚀 调用方式 1: GET 请求</h3>
          <p style="margin: 10px 0;"><strong>请求地址：</strong></p>
          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 15px; border-radius: 5px; overflow-x: auto;">${baseUrl}/query/ip?ip=8.8.8.8&apiKey=${row.apiKey}</pre>
          
          <p style="margin: 15px 0;"><strong>cURL 示例：</strong></p>
          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 15px; border-radius: 5px; overflow-x: auto;">curl "${baseUrl}/query/ip?ip=8.8.8.8&apiKey=${row.apiKey}"</pre>

          <h3 style="color: #67C23A; margin-top: 25px;">🚀 调用方式 2: POST 请求</h3>
          <p style="margin: 10px 0;"><strong>请求地址：</strong></p>
          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 15px; border-radius: 5px; overflow-x: auto;">${baseUrl}/query/ip</pre>
          
          <p style="margin: 15px 0;"><strong>请求头：</strong></p>
          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 15px; border-radius: 5px; overflow-x: auto;">Content-Type: application/json</pre>
          
          <p style="margin: 15px 0;"><strong>请求体：</strong></p>
          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 15px; border-radius: 5px; overflow-x: auto;">{
  "ip": "8.8.8.8",
  "apiKey": "${row.apiKey}"
}</pre>
          
          <p style="margin: 15px 0;"><strong>cURL 示例：</strong></p>
          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 15px; border-radius: 5px; overflow-x: auto;">curl -X POST "${baseUrl}/query/ip" \\
  -H "Content-Type: application/json" \\
  -d '{
    "ip": "8.8.8.8",
    "apiKey": "${row.apiKey}"
  }'</pre>

          <h3 style="color: #67C23A; margin-top: 25px;">📊 返回数据格式</h3>
          
          <p style="margin: 15px 0;"><strong>✅ 成功示例：</strong></p>
          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 15px; border-radius: 5px; overflow-x: auto;">{
  "code": 200,
  "message": "success",
  "data": {
    "ip": "8.8.8.8",
    "country": "美国",
    "province": "",
    "city": "",
    "isp": "Google",
    "found": true
  }
}</pre>

          <p style="margin: 15px 0;"><strong>⚠️ 未找到示例：</strong></p>
          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 15px; border-radius: 5px; overflow-x: auto;">{
  "code": 200,
  "message": "success",
  "data": {
    "ip": "1.2.3.4",
    "country": null,
    "province": null,
    "city": null,
    "isp": null,
    "found": false
  }
}</pre>

          <p style="margin: 15px 0;"><strong>❌ 错误示例：</strong></p>
          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 15px; border-radius: 5px; overflow-x: auto;">{
  "code": 400,
  "message": "IP地址格式不正确",
  "data": null
}</pre>
        </div>
      `
    },
    copyToClipboard(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    },
    async toggleStatus(row) {
      try {
        const newStatus = row.status === 1 ? 0 : 1
        const { data } = await this.$axios.put(`/admin/apikey/${row.id}/status?status=${newStatus}`)
        if (data.code === 200) {
          this.$message.success('状态更新成功')
          this.loadApiKeys()
        }
      } catch (error) {
        this.$message.error('更新失败')
      }
    },
    deleteKey(id) {
      this.$confirm('确定要删除此API Key吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await this.$axios.delete(`/admin/apikey/${id}`)
          if (data.code === 200) {
            this.$message.success('删除成功')
            this.loadApiKeys()
          }
        } catch (error) {
          this.$message.error('删除失败')
        }
      })
    },
    showEditDialog(row) {
      this.editForm = {
        id: row.id,
        apiName: row.apiName,
        dailyLimit: row.dailyLimit
      }
      this.editDialogVisible = true
    },
    async handleEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          try {
            const { data } = await this.$axios.put(`/admin/apikey/${this.editForm.id}`, {
              apiName: this.editForm.apiName,
              dailyLimit: this.editForm.dailyLimit
            })
            if (data.code === 200) {
              this.$message.success('更新成功')
              this.editDialogVisible = false
              this.loadApiKeys()
            } else {
              this.$message.error(data.message)
            }
          } catch (error) {
            this.$message.error('更新失败')
          }
        }
      })
    },
    async handleVerify() {
      if (!this.verifyForm.ip) {
        this.$message.warning('请输入IP地址')
        return
      }
      
      try {
        const { data } = await this.$axios.get('/admin/ip/verify', {
          params: { ip: this.verifyForm.ip }
        })
        if (data.code === 200) {
          this.verifyResult = data.data
        } else {
          this.$message.error(data.message)
        }
      } catch (error) {
        this.$message.error('查询失败')
      }
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('logout')
        this.$router.push('/login')
      })
    },
    showChangePasswordDialog() {
      this.changePasswordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.changePasswordDialogVisible = true
    },
    async handleChangePassword() {
      this.$refs.changePasswordForm.validate(async (valid) => {
        if (valid) {
          try {
            this.changePasswordLoading = true
            const user = this.$store.state.user
            const { data } = await this.$axios.post('/auth/change-password', {
              username: user.username,
              oldPassword: this.changePasswordForm.oldPassword,
              newPassword: this.changePasswordForm.newPassword
            })
            
            if (data.code === 200) {
              this.$message.success('密码修改成功，请重新登录')
              this.changePasswordDialogVisible = false
              
              // 2秒后自动退出登录
              setTimeout(() => {
                this.$store.dispatch('logout')
                this.$router.push('/login')
              }, 2000)
            } else {
              this.$message.error(data.message)
            }
          } catch (error) {
            this.$message.error('修改密码失败: ' + (error.response?.data?.message || error.message))
          } finally {
            this.changePasswordLoading = false
          }
        }
      })
    },
    async handleOnlineUpdate() {
      this.$confirm('确定要从 Gitee 下载最新IP数据吗？<br><br><strong>说明：</strong><br>1. 如果当前有数据，会自动备份<br>2. 下载约40MB文件，需要一定时间<br>3. 下载后会自动导入到数据库', '确认在线更新', {
        confirmButtonText: '开始更新',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(async () => {
        try {
          this.onlineUpdating = true
          const { data } = await this.$axios.post('/admin/ip/online-update')
          
          if (data.code === 200) {
            this.$message.success('在线更新已启动，请稍后...')
            
            // 轮询导入进度（优化：降低轮询频率减少服务器压力）
            const progressInterval = setInterval(async () => {
              const { data: progressData } = await this.$axios.get('/admin/ip/import-progress')
              
              if (progressData.code === 200) {
                const progress = progressData.data
                
                // 更新进度信息
                this.importProgress = {
                  importing: progress.importing,
                  totalLines: progress.totalLines || 0,
                  processedLines: progress.processedLines || 0,
                  message: progress.message || '就绪',
                  percentage: progress.percentage || 0
                }
                
                if (progress.message.includes('失败')) {
                  clearInterval(progressInterval)
                  this.onlineUpdating = false
                  this.$message.error(progress.message)
                  setTimeout(() => {
                    this.importProgress.importing = false
                  }, 3000)
                } else if (progress.message.includes('完成')) {
                  clearInterval(progressInterval)
                  this.onlineUpdating = false
                  this.$message.success('在线更新完成！')
                  this.loadIpDataStats()
                  this.loadBackups()
                  setTimeout(() => {
                    this.importProgress.importing = false
                  }, 5000)
                } else if (!progress.importing) {
                  clearInterval(progressInterval)
                  this.onlineUpdating = false
                }
              }
            }, 2000)  // 优化：改为每2秒更新1次，减少服务器压力
          } else {
            this.onlineUpdating = false
            this.$message.error(data.message)
          }
        } catch (error) {
          this.onlineUpdating = false
          this.$message.error('在线更新失败: ' + error.message)
        }
      }).catch(() => {
        // 取消操作
      })
    },
    restoreBackup(backupId) {
      this.$confirm('确定要恢复此备份吗？当前数据将被覆盖！', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const loading = this.$loading({
            lock: true,
            text: '正在恢复备份...',
            spinner: 'el-icon-loading'
          })
          const { data } = await this.$axios.post(`/admin/ip/restore/${backupId}`)
          loading.close()
          if (data.code === 200) {
            this.$message.success(`备份恢复成功！共恢复 ${data.data.restoredCount} 条数据`)
            this.loadIpDataStats()
          } else {
            this.$message.error(data.message)
          }
        } catch (error) {
          this.$message.error('恢复失败: ' + error.message)
        }
      })
    },
    deleteBackup(backupId) {
      this.$confirm('确定要删除此备份吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await this.$axios.delete(`/admin/ip/backup/${backupId}`)
          if (data.code === 200) {
            this.$message.success('备份已删除')
            this.loadBackups()
          } else {
            this.$message.error(data.message)
          }
        } catch (error) {
          this.$message.error('删除失败')
        }
      })
    },
    applyFilter() {
      const filtered = this.queryLogs.filter(log => {
        if (this.statsFilter.apiName && log.apiName !== this.statsFilter.apiName) {
          return false
        }
        if (this.statsFilter.clientIp && log.clientIp !== this.statsFilter.clientIp) {
          return false
        }
        if (this.statsFilter.dateRange) {
          const startDate = new Date(this.statsFilter.dateRange[0]).getTime()
          const endDate = new Date(this.statsFilter.dateRange[1]).getTime()
          const logDate = new Date(log.queryTime).getTime()
          if (logDate < startDate || logDate > endDate) {
            return false
          }
        }
        return true
      })
      this.filteredQueryLogs = this.sortQueryLogs(filtered)
    },
    resetFilter() {
      this.statsFilter = {
        apiName: '',
        clientIp: '',
        dateRange: ''
      }
      this.filteredQueryLogs = [...this.queryLogs]
    },
    showStatsAnalysis() {
      if (this.filteredQueryLogs.length === 0) {
        this.$message.warning('没有数据可以分析')
        return
      }
      
      // 统计API调用次数
      const apiCountMap = {}
      this.filteredQueryLogs.forEach(log => {
        const apiName = log.apiName || '未知API'
        apiCountMap[apiName] = (apiCountMap[apiName] || 0) + 1
      })
      this.apiStats = Object.keys(apiCountMap).map(apiName => ({
        apiName,
        count: apiCountMap[apiName]
      })).sort((a, b) => b.count - a.count)
      
      // 统计地区分布（基于查询结果中的地区信息）
      const locationCountMap = {}
      const locationDetailsMap = {}  // 存储地区详细信息
      
      this.filteredQueryLogs.forEach(log => {
        try {
          const result = JSON.parse(log.queryResult)
          console.log('解析查询结果:', result)  // 调试日志
          
          // 处理不同的响应格式
          let data = result.data || result
          
          if (data) {
            let location = ''
            const country = data.country || ''
            const province = data.province || ''
            const city = data.city || ''
            
            if (country) location += country
            if (province) location += ' ' + province
            if (city) location += ' ' + city
            if (!location) location = '未知地区'
            location = location.trim()
            
            locationCountMap[location] = (locationCountMap[location] || 0) + 1
            
            // 保存地区详细信息
            if (!locationDetailsMap[location]) {
              locationDetailsMap[location] = {
                location: location,
                country: country,
                province: province,
                city: city,
                count: 0
              }
            }
            locationDetailsMap[location].count++
          }
        } catch (e) {
          // 忽略解析错误
          console.error('解析查询结果失败:', log.queryResult, e)
        }
      })
      
      this.locationStats = Object.keys(locationCountMap).map(location => ({
        location,
        count: locationCountMap[location]
      })).sort((a, b) => b.count - a.count)
      
      // 保存详细信息供筛选使用
      this.locationDetails = Object.values(locationDetailsMap).sort((a, b) => b.count - a.count)
      this.filteredLocationStats = [...this.locationStats]
      
      // 重置筛选条件
      this.locationFilter = {
        country: '',
        province: '',
        city: ''
      }
      
      console.log('地区统计结果:', this.locationStats)  // 调试日志
      console.log('地区详细信息:', this.locationDetails)  // 调试日志
      
      // 统计客户端IP
      const clientIpCountMap = {}
      const clientIpLocationMap = {}
      this.filteredQueryLogs.forEach(log => {
        const clientIp = log.clientIp || '未知IP'
        clientIpCountMap[clientIp] = (clientIpCountMap[clientIp] || 0) + 1
        if (!clientIpLocationMap[clientIp]) {
          clientIpLocationMap[clientIp] = log.clientLocation || '-'
        }
      })
      this.clientIpStats = Object.keys(clientIpCountMap).map(clientIp => ({
        clientIp,
        location: clientIpLocationMap[clientIp],
        count: clientIpCountMap[clientIp]
      })).sort((a, b) => b.count - a.count)
      
      // 统计每日查询次数
      const dateCountMap = {}
      this.filteredQueryLogs.forEach(log => {
        let date = '未知日期'
        if (log.queryTime) {
          // 提取 yyyy-mm-dd 格式的日期
          const match = log.queryTime.match(/(\d{4}-\d{2}-\d{2})/)
          if (match) {
            date = match[1]
          }
        }
        dateCountMap[date] = (dateCountMap[date] || 0) + 1
      })
      this.timeStats = Object.keys(dateCountMap).map(date => ({
        date,
        count: dateCountMap[date]
      })).sort((a, b) => b.date.localeCompare(a.date))
      
      this.analysisDialogVisible = true
    },
    // 筛选地区统计
    filterLocationStats() {
      this.filteredLocationStats = this.locationDetails.filter(item => {
        // 国家筛选
        if (this.locationFilter.country && item.country !== this.locationFilter.country) {
          return false
        }
        // 省份筛选
        if (this.locationFilter.province && item.province !== this.locationFilter.province) {
          return false
        }
        // 城市筛选
        if (this.locationFilter.city && item.city !== this.locationFilter.city) {
          return false
        }
        return true
      }).map(item => ({
        location: item.location,
        count: item.count
      })).sort((a, b) => b.count - a.count)
    },
    // 重置地区筛选
    resetLocationFilter() {
      this.locationFilter = {
        country: '',
        province: '',
        city: ''
      }
      this.filteredLocationStats = [...this.locationStats]
    },
    // 自动更新：加载配置
    async loadAutoUpdateConfig() {
      try {
        const { data } = await this.$axios.get('/admin/ip/auto-update/status')
        if (data.code === 200) {
          const d = data.data
          if (!this.autoUpdate) this.$set(this, 'autoUpdate', {})
          this.$set(this.autoUpdate, 'enabled', !!d.enabled)
          this.$set(this.autoUpdate, 'frequency', d.frequency || 'daily')
          this.$set(this.autoUpdate, 'updateHour', d.updateHour ?? 3)
          this.$set(this.autoUpdate, 'updateMinute', d.updateMinute ?? 0)
          this.$set(this.autoUpdate, 'weekDay', d.weekDay ?? 1)
          this.$set(this.autoUpdate, 'monthDay', d.monthDay ?? 1)
          this.$set(this.autoUpdate, 'lastUpdateTime', d.lastUpdateTime || null)
          this.$set(this.autoUpdate, 'lastUpdateStatus', d.lastUpdateStatus || null)
          this.$set(this.autoUpdate, 'lastUpdateMessage', d.lastUpdateMessage || null)
          this.$set(this.autoUpdate, 'nextUpdateTime', d.nextUpdateTime || null)
          const h = (this.autoUpdate.updateHour || 3).toString().padStart(2, '0')
          const m = (this.autoUpdate.updateMinute || 0).toString().padStart(2, '0')
          this.$set(this, 'autoUpdateTime', `${h}:${m}`)
        }
      } catch (e) { /* ignore */ }
    },
    // 自动更新：保存配置
    async saveAutoUpdateConfig() {
      try {
        this.autoUpdateSaving = true
        const time = this.autoUpdateTime || '03:00'
        const [h, m] = time.split(':')
        const body = {
          enabled: this.autoUpdate?.enabled || false,
          frequency: this.autoUpdate?.frequency || 'daily',
          updateHour: parseInt(h),
          updateMinute: parseInt(m),
          weekDay: this.autoUpdate?.weekDay || 1,
          monthDay: this.autoUpdate?.monthDay || 1
        }
        const { data } = await this.$axios.post('/admin/ip/auto-update/config', body)
        this.autoUpdateSaving = false
        if (data.code === 200) {
          this.$message.success('自动更新配置已保存')
          this.loadAutoUpdateConfig()
        } else {
          this.$message.error(data.message)
        }
      } catch (error) {
        this.autoUpdateSaving = false
        this.$message.error('保存失败: ' + error.message)
      }
    },
    // 自动更新：时间选择变化
    onTimeChange(val) {
      this.$set(this, 'autoUpdateTime', val)
    },
    // 自动更新：立即触发
    async triggerAutoUpdate() {
      try {
        this.autoUpdateTriggering = true
        const { data } = await this.$axios.post('/admin/ip/auto-update/trigger')
        this.autoUpdateTriggering = false
        if (data.code === 200) {
          this.$message.success('已触发自动更新')
          this.loadAutoUpdateConfig()
          // 轮询导入进度（优化：降低轮询频率）
          const progressInterval = setInterval(async () => {
            const { data: progressData } = await this.$axios.get('/admin/ip/import-progress')
            if (progressData.code === 200) {
              const progress = progressData.data
              this.importProgress = {
                importing: progress.importing,
                totalLines: progress.totalLines || 0,
                processedLines: progress.processedLines || 0,
                message: progress.message || '就绪',
                percentage: progress.percentage || 0
              }
              if (progress.message?.includes('失败')) {
                clearInterval(progressInterval)
                this.$message.error(progress.message)
                setTimeout(() => { this.importProgress.importing = false }, 3000)
              } else if (progress.message?.includes('完成')) {
                clearInterval(progressInterval)
                this.$message.success('自动更新完成！')
                this.loadIpDataStats()
                this.loadBackups()
                setTimeout(() => { this.importProgress.importing = false }, 5000)
              } else if (!progress.importing) {
                clearInterval(progressInterval)
              }
            }
          }, 2000)  // 优化：改为每2秒更新1次
        } else {
          this.$message.error(data.message)
        }
      } catch (error) {
        this.autoUpdateTriggering = false
        this.$message.error('触发失败: ' + error.message)
      }
    },
    // 工具：时间格式化
    formatDateTime(dt) {
      if (!dt) return null
      const s = typeof dt === 'string' ? dt : String(dt)
      // 兼容 LocalDateTime 字符串
      return s.replace('T', ' ')
    },
    sortQueryLogs(logs) {
      return [...logs].sort((a, b) => {
        const timeA = new Date(a.queryTime || '').getTime()
        const timeB = new Date(b.queryTime || '').getTime()
        if (isNaN(timeA) && isNaN(timeB)) return 0
        if (isNaN(timeA)) return 1
        if (isNaN(timeB)) return -1
        return timeB - timeA
      })
    },
    // 系统日志相关方法
    async loadSystemLogs() {
      try {
        this.systemLogLoading = true
        const params = {
          page: this.systemLogPage,
          size: this.systemLogPageSize
        }
        
        if (this.systemLogFilter.username) {
          params.username = this.systemLogFilter.username
        }
        
        if (this.systemLogFilter.dateRange && this.systemLogFilter.dateRange.length === 2) {
          params.startTime = this.formatDateTimeForApi(this.systemLogFilter.dateRange[0])
          params.endTime = this.formatDateTimeForApi(this.systemLogFilter.dateRange[1])
        }
        
        const { data } = await this.$axios.get('/admin/system-log/list', { params })
        if (data.code === 200) {
          this.systemLogs = data.data.content || []
          this.systemLogTotal = data.data.totalElements || 0
        }
      } catch (error) {
        console.error('加载系统日志失败', error)
        this.$message.error('加载系统日志失败')
      } finally {
        this.systemLogLoading = false
      }
    },
    applySystemLogFilter() {
      this.systemLogPage = 0
      this.loadSystemLogs()
    },
    resetSystemLogFilter() {
      this.systemLogFilter = {
        username: '',
        dateRange: ''
      }
      this.systemLogPage = 0
      this.loadSystemLogs()
    },
    handleSystemLogPageChange(page) {
      this.systemLogPage = page - 1
      this.loadSystemLogs()
    },
    handleSystemLogSizeChange(size) {
      this.systemLogPageSize = size
      this.systemLogPage = 0
      this.loadSystemLogs()
    },
    formatDateTimeForApi(date) {
      if (!date) return null
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      const seconds = String(d.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  height: 100vh;
  background: #f5f7fa;
  position: relative;
  overflow: hidden;
}

/* 科技背景效果 */
.tech-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  pointer-events: none;
  background: #f5f7fa;
}

/* 已移除所有动画效果以提升性能：
   - grid-overlay (网格动画)
   - scan-line (扫描线动画)
   - particles (粒子动画)
   - hologram-lines (全息线动画)
*/

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0 30px;
  position: relative;
  z-index: 10;
  border-bottom: 1px solid #e8e8e8;
}

.header-border {
  display: none;
}

.dashboard-header h2 {
  margin: 0;
  position: relative;
}

.header-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  position: relative;
  z-index: 1;
}

.header-glow {
  /* 已移除发光动画效果以提升性能 */
  display: none;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-name {
  color: #303133;
  font-weight: 500;
}

.header-btn {
  color: #303133 !important;
  font-weight: 500;
  transition: all 0.3s;
}

.header-btn:hover {
  color: #409EFF !important;
}

.dashboard-aside {
  background: #ffffff;
  height: calc(100vh - 60px);
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 10;
  border-right: 1px solid #e8e8e8;
}

.aside-border {
  display: none;
}

.dashboard-main {
  background: #f5f7fa;
  padding: 25px;
  height: calc(100vh - 60px);
  overflow-y: auto;
  position: relative;
  z-index: 10;
}

/* 美化滚动条 */
.dashboard-main::-webkit-scrollbar {
  width: 8px;
}

.dashboard-main::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.dashboard-main::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 4px;
}

.dashboard-main::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

.content-section {
  /* 移除了淡入动画以提升性能 */
}

.stat-card {
  margin-bottom: 20px;
}

.chart-card {
  min-height: 360px;
}

.chart-container {
  width: 100%;
  height: 300px;
}

.chart-container.large {
  height: 400px;
}

.stat-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.stat-icon {
  font-size: 48px;
  color: #409EFF;
}

.stat-value {
  font-size: 32px;
  font-weight: bold;
  color: #303133;
}

.stat-label {
  font-size: 14px;
  color: #606266;
  margin-top: 5px;
  font-weight: 500;
}

/* 菜单项样式优化 */
.dashboard-aside >>> .el-menu {
  border-right: none;
  background: transparent !important;
}

.dashboard-aside >>> .el-menu-item {
  border-left: 3px solid transparent;
  transition: all 0.3s;
  margin: 5px 0;
  background: transparent !important;
}

.dashboard-aside >>> .el-menu-item:hover {
  background: #ecf5ff !important;
  border-left-color: #409EFF;
}

.dashboard-aside >>> .el-menu-item.is-active {
  background: #ecf5ff !important;
  border-left-color: #409EFF;
  color: #409EFF !important;
  font-weight: 600;
}

.dashboard-aside >>> .el-menu-item i {
  color: inherit;
}

/* 卡片样式优化 */
.dashboard-main >>> .el-card {
  border-radius: 4px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  background: #ffffff !important;
  position: relative;
  overflow: hidden;
}

.dashboard-main >>> .el-card:hover {
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
}

.dashboard-main >>> .el-card__header {
  background: #ffffff !important;
  border-bottom: 1px solid #e8e8e8;
  font-weight: 600;
  color: #303133 !important;
  padding: 15px 20px !important;
}

.dashboard-main >>> .el-card__body {
  color: #303133 !important;
  background: #ffffff !important;
  padding: 20px !important;
}

/* 按钮样式优化 - 使用标准样式 */
.dashboard-main >>> .el-button--primary {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
  color: #ffffff !important;
}

.dashboard-main >>> .el-button--primary:hover {
  background-color: #66b1ff !important;
  border-color: #66b1ff !important;
}

.dashboard-main >>> .el-button--success {
  background-color: #67C23A !important;
  border-color: #67C23A !important;
  color: #ffffff !important;
}

.dashboard-main >>> .el-button--success:hover {
  background-color: #85ce61 !important;
  border-color: #85ce61 !important;
}

.dashboard-main >>> .el-button--danger {
  background-color: #F56C6C !important;
  border-color: #F56C6C !important;
  color: #ffffff !important;
}

.dashboard-main >>> .el-button--danger:hover {
  background-color: #f78989 !important;
  border-color: #f78989 !important;
}

.dashboard-main >>> .el-button--warning {
  background-color: #E6A23C !important;
  border-color: #E6A23C !important;
  color: #ffffff !important;
}

.dashboard-main >>> .el-button--warning:hover {
  background-color: #ebb563 !important;
  border-color: #ebb563 !important;
}

.stats-reset-btn {
  background-color: #ffffff !important;
  border-color: #dcdfe6 !important;
  color: #303133 !important;
}

.stats-reset-btn:hover {
  border-color: #409EFF !important;
  color: #409EFF !important;
}

.api-interface-btn {
  background-color: #ffffff !important;
  border-color: #dcdfe6 !important;
  color: #303133 !important;
}

.api-interface-btn:hover {
  border-color: #409EFF !important;
  color: #409EFF !important;
}

.verify-result {
  margin-top: 20px;
}

.verify-result h3 {
  margin-bottom: 15px;
  color: #303133;
}

/* 表格样式 */
.dashboard-main >>> .el-table {
  background: #ffffff !important;
  border: 1px solid #e8e8e8;
}

.dashboard-main >>> .el-table th {
  background: #fafafa !important;
  color: #303133 !important;
  border-bottom: 1px solid #e8e8e8 !important;
  font-weight: 600 !important;
  padding: 12px 0 !important;
}

.dashboard-main >>> .el-table td {
  background: #ffffff !important;
  color: #303133 !important;
  border-bottom: 1px solid #e8e8e8 !important;
  padding: 12px 0 !important;
}

.dashboard-main >>> .el-table tr:hover > td {
  background: #f5f7fa !important;
}

.dashboard-main >>> .el-table--border {
  border: 1px solid #e8e8e8;
}

.dashboard-main >>> .el-table--border::after {
  background-color: #e8e8e8;
}

.dashboard-main >>> .el-table--border th,
.dashboard-main >>> .el-table--border td {
  border-right: 1px solid #e8e8e8;
}

/* 输入框样式 */
.dashboard-main >>> .el-input__inner {
  background: #ffffff !important;
  border: 1px solid #dcdfe6 !important;
  color: #303133 !important;
}

.dashboard-main >>> .el-input__inner:focus {
  border-color: #409EFF !important;
  background: #ffffff !important;
}

.dashboard-main >>> .el-input__inner::placeholder {
  color: #c0c4cc !important;
}

/* 标签样式 - 使用标准样式 */
.dashboard-main >>> .el-tag {
  background-color: #ecf5ff !important;
  border-color: #b3d8ff !important;
  color: #409EFF !important;
  font-weight: 500;
}

.dashboard-main >>> .el-tag--success {
  background-color: #f0f9ff !important;
  border-color: #b3e19d !important;
  color: #67C23A !important;
}

.dashboard-main >>> .el-tag--danger {
  background-color: #fef0f0 !important;
  border-color: #fbc4c4 !important;
  color: #F56C6C !important;
}

.dashboard-main >>> .el-tag--info {
  background-color: #f4f4f5 !important;
  border-color: #d3d4d6 !important;
  color: #909399 !important;
}

/* 描述列表样式 */
.dashboard-main >>> .el-descriptions__label {
  color: #909399 !important;
  font-weight: 600;
}

.dashboard-main >>> .el-descriptions__content {
  color: #303133 !important;
}

.dashboard-main >>> .el-descriptions__table {
  border: 1px solid #e8e8e8 !important;
  background: #ffffff !important;
}

.dashboard-main >>> .el-descriptions__table th,
.dashboard-main >>> .el-descriptions__table td {
  border: 1px solid #e8e8e8 !important;
  background: #ffffff !important;
  padding: 12px !important;
}

/* 进度条样式 - 使用标准样式 */
.dashboard-main >>> .el-progress-bar__outer {
  background: #e4e7ed !important;
  border: none !important;
}

.dashboard-main >>> .el-progress-bar__inner {
  background-color: #409EFF !important;
}

/* 分割线样式 */
.dashboard-main >>> .el-divider {
  background-color: #e8e8e8 !important;
}

.dashboard-main >>> .el-divider__text {
  background: #f5f7fa !important;
  color: #909399 !important;
  font-weight: 500;
}

/* 空状态样式 */
.dashboard-main >>> .el-empty__description {
  color: #909399 !important;
}

/* 表单样式 */
.dashboard-main >>> .el-form-item__label {
  color: #303133 !important;
  font-weight: 500;
}

.dashboard-main >>> .el-form-item__content {
  color: #303133 !important;
}

/* 选择器样式 */
.dashboard-main >>> .el-select .el-input__inner {
  background: #ffffff !important;
  border: 1px solid #dcdfe6 !important;
  color: #303133 !important;
}

.dashboard-main >>> .el-select-dropdown {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
}

.dashboard-main >>> .el-select-dropdown__item {
  color: #303133 !important;
  background: #ffffff !important;
}

.dashboard-main >>> .el-select-dropdown__item:hover {
  background: #f5f7fa !important;
  color: #409EFF !important;
}

.dashboard-main >>> .el-select-dropdown__item.selected {
  background: #ecf5ff !important;
  color: #409EFF !important;
}

/* 日期选择器样式 */
.dashboard-main >>> .el-date-editor .el-input__inner {
  background: #ffffff !important;
  border: 1px solid #dcdfe6 !important;
  color: #303133 !important;
}

/* 数字输入框样式 */
.dashboard-main >>> .el-input-number .el-input__inner {
  background: #ffffff !important;
  border: 1px solid #dcdfe6 !important;
  color: #303133 !important;
}

/* 开关样式 */
.dashboard-main >>> .el-switch__core {
  background: #dcdfe6 !important;
  border: 1px solid #dcdfe6 !important;
}

.dashboard-main >>> .el-switch.is-checked .el-switch__core {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}

/* 文本颜色 */
.dashboard-main {
  color: #303133 !important;
}

.dashboard-main >>> p,
.dashboard-main >>> span,
.dashboard-main >>> div {
  color: #303133 !important;
}

/* 对话框样式 - 数据分析等对话框 */
.dashboard-container >>> .el-dialog {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
}

.dashboard-container >>> .el-dialog__header {
  background: #ffffff !important;
  border-bottom: 1px solid #e8e8e8 !important;
  padding: 20px 20px 15px !important;
}

.dashboard-container >>> .el-dialog__title {
  color: #303133 !important;
  font-weight: 600 !important;
  font-size: 18px !important;
}

.dashboard-container >>> .el-dialog__headerbtn .el-dialog__close {
  color: #909399 !important;
  font-size: 20px !important;
}

.dashboard-container >>> .el-dialog__headerbtn:hover .el-dialog__close {
  color: #606266 !important;
}

.dashboard-container >>> .el-dialog__body {
  background: #ffffff !important;
  color: #303133 !important;
  padding: 20px !important;
}

.dashboard-container >>> .el-dialog__footer {
  background: #ffffff !important;
  border-top: 1px solid #e8e8e8 !important;
  padding: 15px 20px !important;
}

/* 标签页样式 */
.dashboard-container >>> .el-tabs {
  background: transparent !important;
}

.dashboard-container >>> .el-tabs__header {
  margin: 0 0 20px 0 !important;
  border-bottom: 1px solid #e8e8e8 !important;
}

.dashboard-container >>> .el-tabs__nav {
  border: none !important;
}

.dashboard-container >>> .el-tabs__item {
  color: #303133 !important;
  border: none !important;
  padding: 0 20px !important;
  height: 45px !important;
  line-height: 45px !important;
  font-weight: 500 !important;
  transition: all 0.3s !important;
}

.dashboard-container >>> .el-tabs__item:hover {
  color: #409EFF !important;
}

.dashboard-container >>> .el-tabs__item.is-active {
  color: #409EFF !important;
  font-weight: 600 !important;
}

.dashboard-container >>> .el-tabs__active-bar {
  background-color: #409EFF !important;
  height: 2px !important;
}

.dashboard-container >>> .el-tabs__content {
  color: #303133 !important;
}

/* 对话框内的表格样式 */
.dashboard-container >>> .el-dialog .el-table {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
}

.dashboard-container >>> .el-dialog .el-table th {
  background: #fafafa !important;
  color: #303133 !important;
  border-bottom: 1px solid #e8e8e8 !important;
  font-weight: 600 !important;
}

.dashboard-container >>> .el-dialog .el-table td {
  background: #ffffff !important;
  color: #303133 !important;
  border-bottom: 1px solid #e8e8e8 !important;
}

.dashboard-container >>> .el-dialog .el-table tr:hover > td {
  background: #f5f7fa !important;
}

.dashboard-container >>> .el-dialog .el-table--border {
  border: 1px solid #e8e8e8 !important;
}

.dashboard-container >>> .el-dialog .el-table--border::after {
  background-color: #e8e8e8 !important;
}

.dashboard-container >>> .el-dialog .el-table--border th,
.dashboard-container >>> .el-dialog .el-table--border td {
  border-right: 1px solid #e8e8e8 !important;
}

/* 对话框内的表单样式 */
.dashboard-container >>> .el-dialog .el-form-item__label {
  color: #303133 !important;
  font-weight: 500 !important;
}

.dashboard-container >>> .el-dialog .el-select .el-input__inner {
  background: #ffffff !important;
  border: 1px solid #dcdfe6 !important;
  color: #303133 !important;
}

.dashboard-container >>> .el-dialog .el-button {
  background-color: #ffffff !important;
  border-color: #dcdfe6 !important;
  color: #303133 !important;
}

.dashboard-container >>> .el-dialog .el-button:hover {
  border-color: #409EFF !important;
  color: #409EFF !important;
}

.dashboard-container >>> .el-dialog .el-button--primary {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
  color: #ffffff !important;
}

.dashboard-container >>> .el-dialog .el-button--primary:hover {
  background-color: #66b1ff !important;
  border-color: #66b1ff !important;
}

/* API预览对话框样式 */
.dashboard-container >>> .api-preview-content {
  background: #ffffff !important;
  color: #303133 !important;
  border: 1px solid #e8e8e8 !important;
  padding: 20px !important;
  border-radius: 4px !important;
}

.dashboard-container >>> .api-preview-content h2 {
  color: #303133 !important;
  border-bottom: 1px solid #e8e8e8 !important;
}

.dashboard-container >>> .api-preview-content h3 {
  color: #409EFF !important;
}

.dashboard-container >>> .api-preview-content pre {
  background: #f5f7fa !important;
  border: 1px solid #e8e8e8 !important;
  color: #303133 !important;
}

.dashboard-container >>> .api-preview-content code {
  background: #f5f7fa !important;
  color: #e6a23c !important;
  border: 1px solid #e8e8e8 !important;
}

.dashboard-container >>> .api-preview-content table {
  border: 1px solid #e8e8e8 !important;
}

.dashboard-container >>> .api-preview-content table td {
  border: 1px solid #e8e8e8 !important;
  background: #ffffff !important;
  color: #303133 !important;
}

.dashboard-container >>> .api-preview-content table tr {
  background: #ffffff !important;
}

/* 去除按钮下方的线条 */
.el-table .el-table__body td .cell {
  padding: 0 !important;
  height: 100%;
}

.el-table .el-table__body td {
  padding: 0 !important;
}

.el-table .el-button--mini {
  margin: 0;
}

/* 导入确认对话框样式 */
.import-confirm-dialog {
  min-width: 500px;
}

.import-confirm-dialog .el-message-box__message {
  line-height: 1.8;
}

.import-confirm-dialog ul {
  list-style-type: disc;
}

/* API预览对话框样式 */
.api-preview-content {
  max-height: 70vh;
  overflow-y: auto;
  padding: 10px;
}

.api-preview-content pre {
  font-size: 13px;
  line-height: 1.6;
  margin: 0;
}

.api-preview-content h2 {
  margin: 0 0 15px 0;
}

.api-preview-content h3 {
  margin: 20px 0 10px 0;
}

.api-preview-content::-webkit-scrollbar {
  width: 8px;
}

.api-preview-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.api-preview-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.api-preview-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
